import React from "react";
import { Box, Typography, Grid, Card, CardActionArea, CardContent, Avatar } from "@mui/material";
import { School, People } from "@mui/icons-material";

interface Props {
  formData: any;
  setFormData: (data: any) => void;
}

const RoleSelection: React.FC<Props> = ({ formData, setFormData }) => {
  const roles = [
    { key: "Elternteil / Schüler", label: "Elternteil / Schüler", icon: <School fontSize="large" /> },
    { key: "Vertreter / Sozialarbeiter", label: "Vertreter / Sozialarbeiter", icon: <People fontSize="large" /> },
  ];

  const handleSelect = (role: string) => {
    setFormData({
      ...formData,
      role,
    });
  };

  return (
    <Box sx={{ textAlign: "center", mt: 4 }}>
      <Typography variant="h1" sx={{ mb: 3, fontWeight: "bold", color: "primary.main" }}>
        Wählen Sie Ihre Rolle
      </Typography>

      <Grid container spacing={2} justifyContent="center">
        {roles.map((role) => (
          <Grid item xs={12} sm={6} key={role.key}>
            <Card
              onClick={() => handleSelect(role.key)}
              sx={{
                border: formData.role === role.key ? "2px solid #1976d2" : "1px solid #ddd",
                background: formData.role === role.key ? "#e3f2fd" : "#ffffff",
                borderRadius: "12px",
                transition: "all 0.3s ease-in-out",
                boxShadow: formData.role === role.key
                  ? "0px 4px 8px rgba(25, 118, 210, 0.3)"
                  : "0px 2px 5px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0px 6px 15px rgba(25, 118, 210, 0.3)",
                },
                textAlign: "center",
                padding: 2,
                cursor: "pointer",
              }}
            >
              <CardActionArea>
                <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <Avatar sx={{ bgcolor: "#1976d2", width: 50, height: 50, mb: 1 }}>{role.icon}</Avatar>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      color: formData.role === role.key ? "#1976d2" : "#37474f",
                      transition: "0.3s",
                      fontSize: "1rem",
                    }}
                  >
                    {role.label}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RoleSelection;
